import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { CdkTableModule } from '@angular/cdk/table';
import * as _ from 'lodash';

import { FcpSearchModule } from '../fcp-search';
import { FcpLoadMoreComponent } from '../fcp-load-more';
import { CommonModule } from '@angular/common';
import { CdkOverlayOrigin, ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { FcpTooltipModule, TooltipPositionX, TooltipPositionY } from '../fcp-tooltip';
import { FcpIconModule } from '../fcp-icon';

@Component({
    selector: 'fcp-table',
    imports: [
        FcpSearchModule,
        FcpLoadMoreComponent,
        CdkTableModule,
        CommonModule,
        CdkOverlayOrigin,
        OverlayModule,
        FcpIconModule,
        FcpTooltipModule
    ],
    templateUrl: './fcp-table.component.html',
    styleUrls: ['./fcp-table.component.less']
})
export class FcpTableComponent implements OnChanges {
    @Input() rows: object[];
    @Input() totalItems: number;
    @Input() columns: FcpTableColumn[];
    @Input() columnsToDisplay: string[];
    @Input() tableConfig: FcpTableConfig;
    @Input() emptyTableTemplate: TemplateRef<any>;

    @Output() searchQueryChange = new EventEmitter<string>();
    @Output() loadMoreClicked = new EventEmitter<void>();
    @Output() rowClicked = new EventEmitter<object>();

    public tooltipPosition: ConnectedPosition = {
        originX: TooltipPositionX.Center,
        originY: TooltipPositionY.Top,
        overlayX: TooltipPositionX.Center,
        overlayY: TooltipPositionY.Bottom
    };

    public tooltipOpen: Record<string, boolean> = {};

    public searchQuery: string;
    public progress: number;
    public showSearch: boolean;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.rows || changes.totalItems) {
            this.progress = this.totalItems ? (this.rows?.length / this.totalItems) * 100 : 0;
        }
        if (changes.tableConfig || changes.totalItems) {
            if (this.totalItems === 0) {
                this.showSearch = this.tableConfig?.search?.show && this.searchQuery?.length > 0;
            } else {
                this.showSearch = this.tableConfig?.search?.show;
            }
        }
    }

    onSearchChange(event: string) {
        this.searchQuery = event;
        this.searchQueryChange.emit(event);
    }

    onLoadMoreClicked() {
        this.loadMoreClicked.emit();
    }

    onRowClicked(row: object) {
        this.rowClicked.emit(row);
    }
}

export type FcpTableConfig = {
    search?: {
        show?: boolean;
        placeholder?: string;
    };
    loadMore?: {
        label?: string;
        buttonLabel?: string;
    };
};

export type FcpTableColumn = {
    id: string;
    title: string;
    cellTemplate?: TemplateRef<any>;
    width?: string;
    tooltip?: FcpTableTooltipConfig;
    sortable?: boolean;
    hidden?: boolean;
};
export interface FcpTableTooltipConfig {
    title: string;
    icon: string[];
}
